export default __webpack_public_path__ + "static/media/coffeeBeans.bc0568a9.png";